var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataComboBox',{attrs:{"config":_vm.config},model:{value:(_vm.pageId),callback:function ($$v) {_vm.pageId=$$v},expression:"pageId"}})}
var staticRenderFns = []

export { render, staticRenderFns }